import { $authHost, $host } from ".";
import { jwtDecode } from 'jwt-decode';


export const registration = async (email, password) => {
    try {
        const { data } = await $host.post('api/user/registration', { email, password, role: 'guest' });

        // Check if there are errors in the response
        if (data.errors) {
            return (data)
        } else {
            localStorage.setItem('token', data);
            return jwtDecode(data);
        }
    } catch (error) {
        // Handle network or other errors that may occur during the request
        console.error('Error during registration:', error.message);
    }
};


export const login = async (email, password) => {
  try {
    const { data } = await $host.post('api/user/login', { email, password })
    if (typeof data !== 'string' || !data.trim()) {
      throw new Error('Invalid token received')
    }

    localStorage.setItem('token', data)
    return jwtDecode(data)
  } catch (error) {
    console.log(error)
    console.error('Login failed:', error)
    throw error // rethrow so caller can handle it (e.g. show toast or set error state)
  }
}


export const check = async () => {
    const { data } = await $authHost.get('api/user/auth')
    localStorage.setItem('token', data)
    return jwtDecode(data)
}